(function () {
  function initCloudflarePlayers(root) {
    if (!root || !window.CloudflareHls) return;

    root.querySelectorAll('[data-slideshow-cfs-player][data-cfs-src]:not([data-cfs-ready])').forEach((player) => {
      const src = player.getAttribute('data-cfs-src');
      if (!src) return;

      player.setAttribute('data-cfs-ready', 'true');
      player.innerHTML = '';

      const videoSection = player.closest('.video-section');

      window.CloudflareHls.mountVideo(player, src, {
        videoClass: 'slideshow-cfs-video block w-full h-full',
        autoplay: true,
        loop: true,
        muted: true,
        controls: false,
        objectFit: 'cover',
        onPlaying: () => {
          if (videoSection) videoSection.classList.add('video-section--played');
        }
      });
    });
  }

  function boot(root) {
    initCloudflarePlayers(root);
    if (window.CloudflareHls) {
      window.CloudflareHls.loadHls(() => {});
    }
  }

  function whenReady(callback) {
    if (window.CloudflareHls) {
      callback();
      return;
    }

    document.addEventListener('cloudflare-hls:ready', callback, { once: true });
  }

  if (!window.__slideshowCloudflareListeners) {
    window.__slideshowCloudflareListeners = true;

    document.addEventListener('DOMContentLoaded', () => {
      whenReady(() => boot(document));
    });

    document.addEventListener('shopify:section:load', (event) => {
      whenReady(() => boot(event.target));
    });
  }

  whenReady(() => {
    if (document.readyState !== 'loading') {
      boot(document);
    }
  });
})();
